module.exports = __webpack_public_path__ + "img/gb6173.prt.5a181c32.jpg";